import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ScrollToTop — on every forward route change (pathname), reset scroll to the top so a new page
 * never arrives at the previous page's scroll position (e.g. after clicking a bottom-of-page
 * button). Back/forward (POP) navigations are skipped so the browser restores the prior scroll
 * position naturally.
 *
 * The admin shell scrolls inside its own <main id="admin-scroll-container"> (overflow-auto), not
 * the window — so we reset that container too; window.scrollTo alone leaves admin pages at the
 * previous scroll. Mounted once inside the router.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType(); // 'PUSH' | 'REPLACE' | 'POP'

  useEffect(() => {
    // Back/forward: let the browser restore the remembered scroll position.
    if (navType === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    const adminMain = document.getElementById('admin-scroll-container');
    if (adminMain && typeof adminMain.scrollTo === 'function') {
      adminMain.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [pathname, navType]);

  return null;
};

export default ScrollToTop;
